import React from 'react';

export interface GrillaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const GrillaIcon: React.FC<GrillaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 3.662H3v7h7zm11 0h-7v7h7zm0 11h-7v7h7zm-11 0H3v7h7z"/>
    </svg>
  );
};

export default GrillaIcon;
